import React, { useContext } from "react";
import { ErrorBoundary, Page, hasActiveFilters } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/networkingSlice";
import { ExportButton } from "../common";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetNetworkingQuery } from "../services/networking.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { getQueryStatus } from "../utils";
import Filter from "./Filter/Filter";
import NetworkingTable from "./NetworkingTable";
const Networking = () => {
    var _a;
    const dispatch = useReportDispatch();
    const { reportId, diffId, roles, onReportExport, activeExport } = useContext(ReportContext);
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data: fetchedData, isLoading, isFetching, isError, error, } = useGetNetworkingQuery({
        filter,
        sort,
        pagination,
        ui_id: reportId,
    });
    const data = fetchedData
        ? fetchedData
        : {
            networking: [],
            match_count: 0,
            next_page: "",
            previous_page: "",
        };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Networking", details: [
                formatCount((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.networking) !== null && _a !== void 0 ? _a : 0, "URI"),
            ], actions: roles.canExportUri ? (React.createElement(ExportButton, { id: "networking-export-as-uri", text: "Export as CSV", onClick: () => onReportExport === null || onReportExport === void 0 ? void 0 : onReportExport("uri"), isDisabled: activeExport.uri })) : undefined }),
        React.createElement(Page.Filters, { found: {
                id: "networking-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(NetworkingTable, { networkingItems: data.networking, sort: sort, searchRegex: filter.search_regex, filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => dispatch(filterUpdated(initFilter)),
                }, onSortChange: (sort) => dispatch(sortUpdated(sort)), status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data: fetchedData,
                }), itemCount: data.match_count, pagination: pagination, onPaginationChange: (pagination) => dispatch(paginationUpdated(pagination)) }))));
};
const NetworkingPage = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorBoundary, { key: "networking" },
            React.createElement(Networking, null))));
};
export default NetworkingPage;
//# sourceMappingURL=Networking.js.map